// @ts-check
// request
/**
 * API Request Base Class.
 * @class APIRequestBase
 */
export class APIRequestBase {
    /** @type {boolean} */
    mock = false
}

/**
 * @class CheckLoggedinRequest
 */
export class GetSampleRequest extends APIRequestBase {
    /**
     * @constructor
     */
    constructor() {
        super()
    }
}

// response
/**
 * API Response Base Class.
 * @class APIResponseBase
 */
class APIResponseBase {
    /** @type {any} */
    data = null
    /** @type {number} */
    status = null
    /** @type {any} */
    header = null
}

export class APIResponse extends APIResponseBase {}
